import { SignUp } from "@clerk/react";
import Mascot from "@/components/Mascot";
import { Link } from "react-router-dom";

export default function SignUpPage() {
  return (
    <div className="min-h-screen bg-[var(--tp-bg)] grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col items-center justify-center p-10 bg-[#EBFBD6] border-r-[3px] border-[#374151]">
        <Mascot size={220} />
        <h2 className="mt-8 text-4xl font-black tracking-tight text-center">Join the roll!</h2>
        <p className="mt-3 text-lg text-slate-700 max-w-sm text-center">10 free lives every day. Earn more by watching tiny ads.</p>
      </div>
      <div className="flex flex-col items-center justify-center p-6">
        <Link to="/" className="font-black mb-6 text-slate-700 hover:underline" data-testid="back-home">← Back to home</Link>
        <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
      </div>
    </div>
  );
}
